import React from 'react';
import { ArrowRightIcon, ScaleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section className="bg-accent px-5 py-16 text-center text-ink md:px-8 md:py-20" data-id="element-57" data-mp="c6skzian4add">
      <FadeIn className="mx-auto max-w-3xl" data-id="element-58" data-mp="c4o7c8mxvwzw">
        <ScaleIcon size={32} className="mx-auto" strokeWidth={1.6} aria-hidden="true" data-id="element-59" data-mp="84xjodsplwzl" />
        <p className="mt-4 text-sm font-bold uppercase tracking-[0.2em]" data-id="element-60" data-mp="m33zmexpdcaz">
          CONVERSION ELITE™
        </p>
        <h2 className="mt-3 font-display text-3xl font-bold leading-tight md:text-5xl" data-id="element-61" data-mp="h3rcru6u058e">
          El próximo expediente no tiene que empezar desde cero.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed md:text-lg" data-id="element-62" data-mp="qwzu37erch1e">
          Podés empezar a trabajar con un tratado desarrollado por abogados,
          pensado para abogados, con modelos, contratos, jurisprudencia y
          estrategias listas para aplicar.
        </p>
        <motion.a href="#adquirir" whileHover={{
        y: -2
      }} whileTap={{
        scale: 0.98
      }} className="mt-8 inline-flex items-center gap-2 bg-ink px-7 py-4 text-sm font-extrabold uppercase tracking-wide text-white shadow-[0_10px_25px_rgba(0,0,0,0.18)] transition-colors hover:bg-black focus:outline-none focus:ring-2 focus:ring-ink focus:ring-offset-2 focus:ring-offset-accent" data-id="element-63" data-mp="2c5pw1su5d814">
          Quiero mi tratado ahora
          <ArrowRightIcon size={19} aria-hidden="true" data-id="element-64" data-mp="301k92qk7y6xu" />
        </motion.a>
      </FadeIn>
    </section>;
}